import React, { useContext, useEffect, useState } from "react";
import http from "../../services/http-commons.js";
import OrderNoTransaction from "./OrderNoTransaction.js";
import { SetAllContext } from "../../services/AllContext.js";
import { Modal } from "bootstrap";
import { toast } from "react-toastify";

import "./Order.scss";

const OrderItem = () => {
  const { orderId } = useContext(SetAllContext);

  // ==================== State =========================
  const [getOrderItems, setOrderItems] = useState(null);
  const [selectedItem, setSelectedItem] = useState(null);
  const [returnReason, setReturnReason] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);

  // =================== Effects =================
  useEffect(() => {
    if (!orderId) return;

    http.ORDERITEMSHTTP.get(`/order_item/${orderId}`)
      .then((response) => {
        setOrderItems(response.data);
      })
      .catch((error) => {
        console.log("ERROR", error);
      });
  }, [orderId]);

  // =================== Open Modal ===================
  const openReturnModal = (item) => {
    setSelectedItem(item);
    setReturnReason("");

    const modal = new Modal(document.getElementById("returnProductModal"));

    modal.show();
  };

  // =================== Return Product ===================
  const returnProduct = async () => {
    if (!returnReason.trim()) {
      toast.error("Please provide a reason for returning this product.");
      return;
    }

    try {
      setIsSubmitting(true);

      const request = http.ORDERITEMSHTTP.post(
        `/return-item/${selectedItem.id}/`,
        null,
        {
          params: {
            return_reason: returnReason.trim(),
          },
        },
      );

      toast.promise(request, {
        pending: "Submitting return request...",
        success: "Return request submitted successfully! 🎉",
        error: "Failed to submit return request 😞",
      });

      const response = await request;

      if (response.status === 200) {
        const modal = Modal.getInstance(
          document.getElementById("returnProductModal"),
        );

        modal.hide();

        setReturnReason("");
        setSelectedItem(null);
      }
    } catch (error) {
      console.log(error);
      toast.error(
        `${
          error.response.data ? error.response.data.detail : "An error occured"
        }`,
        {
          autoClose: 3000, // 3 seconds
        },
      );
    } finally {
      setIsSubmitting(false);
    }
  };

  if (!getOrderItems) {
    return <div>Loading...</div>;
  }

  return (
    <div className="order-trans">
      <div className="order-trans-buttons">
        <button
          className="btn btn-primary col-12"
          style={{ marginRight: "3px" }}
        >
          Order Items
        </button>
      </div>

      {getOrderItems.length > 0 ? (
        getOrderItems.map((item, index) => (
          <div key={index} className="order-trans-content">
            <div className="order-trans-items">
              <div className="col-md-3 order-trans-items-img">
                <img
                  src={item?.product?.images || ""}
                  alt={item?.product?.name || ""}
                  style={{
                    width: "100px",
                    height: "100px",
                  }}
                />
              </div>

              <div className="col-md-7 order-trans-items-product">
                <h6>{item?.product?.name || ""}</h6>
                <p>Vendor: Banke Grocery Store</p>
                <p>Quantity: {item?.quantity || ""}</p>
              </div>

              <div className="col-md-2 d-flex flex-column justify-content-center align-items-center">
                <p>
                  <strong>₦{item?.total_price?.toLocaleString() || ""}</strong>
                </p>

                <button
                  className="btn btn-outline-danger btn-sm"
                  onClick={() => openReturnModal(item)}
                >
                  Return Item
                </button>
              </div>
            </div>
          </div>
        ))
      ) : (
        <OrderNoTransaction />
      )}

      {/* ================= Return Product Modal ================= */}
      <div
        className="modal fade"
        id="returnProductModal"
        data-bs-backdrop="static"
        data-bs-keyboard="false"
        tabIndex="-1"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="container-fluid modal-content">
            <p
              data-bs-dismiss="modal"
              className="d-flex justify-content-end align-items-center"
            >
              <i
                style={{ cursor: "pointer" }}
                className="fa-solid fa-xmark"
              ></i>
            </p>

            <div>
              <h4
                style={{
                  fontSize: "21px",
                  fontWeight: "700",
                  color: "#061D33",
                  fontFamily: "Montserrat",
                  marginBottom: "0",
                }}
              >
                Return Product
              </h4>

              <p
                style={{
                  fontSize: "12px",
                  fontWeight: "400",
                  textAlign: "justify",
                  color: "#7B7B7B",
                  marginTop: "5px",
                  marginBottom: "20px",
                }}
              >
                Are you sure you want to return this product? Kindly provide a
                reason for the return request.
              </p>
            </div>

            {selectedItem && (
              <>
                <div
                  className="d-flex align-items-center"
                  style={{
                    border: "1px solid #e5e5e5",
                    borderRadius: "10px",
                    padding: "15px",
                    marginBottom: "20px",
                  }}
                >
                  <img
                    src={selectedItem?.product?.images || ""}
                    alt={selectedItem?.product?.name || ""}
                    style={{
                      width: "90px",
                      height: "90px",
                      objectFit: "cover",
                      marginRight: "15px",
                    }}
                  />

                  <div>
                    <h6>{selectedItem?.product?.name}</h6>

                    <p
                      style={{
                        color: "#7B7B7B",
                        marginBottom: "5px",
                      }}
                    >
                      Quantity: {selectedItem?.quantity}
                    </p>

                    <p
                      style={{
                        fontWeight: "700",
                        marginBottom: "0",
                      }}
                    >
                      ₦{selectedItem?.total_price?.toLocaleString()}
                    </p>
                  </div>
                </div>

                <div className="mb-3">
                  <label style={{ color: "grey" }} className="form-label">
                    <strong>Reason for Return</strong>
                  </label>

                  <textarea
                    className="form-control"
                    rows="4"
                    placeholder="Tell us why you want to return this product..."
                    value={returnReason}
                    onChange={(e) => setReturnReason(e.target.value)}
                  />
                </div>

                <button
                  type="button"
                  className="btn btn-danger col-12"
                  onClick={returnProduct}
                  disabled={isSubmitting}
                >
                  {isSubmitting ? "Submitting..." : "Return Product"}
                </button>
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default OrderItem;
